"use client"

import { TrustBadges } from "@shared/ui/landing/trust-badges"
import { LiveBadge } from "@shared/ui/landing/status-tag"
import { SectionContainer } from "@shared/ui/landing/section-container"

import { HeroCtaButtons } from "@/components/hero-cta-buttons"
import { HeroShieldVisual } from "@/components/visuals/hero-shield-visual"
import { useTranslations } from "@/lib/i18n/client"

export function HeroSection() {
  const t = useTranslations("hero")
  const tTrust = useTranslations("trust")

  return (
    <SectionContainer className="relative overflow-hidden pb-8 pt-10 md:pt-16">
      <div className="cyber-glow pointer-events-none absolute inset-0" aria-hidden="true" />
      <div className="grid items-center gap-10 lg:grid-cols-2 lg:gap-16">
        <div className="relative z-10 space-y-6">
          <LiveBadge label={t("liveProtection")} />
          <h1 className="text-3xl font-bold leading-tight tracking-tight sm:text-4xl md:text-5xl">
            <span className="cyber-text-gradient">{t("title")}</span>
          </h1>
          <p className="max-w-lg text-base text-muted-foreground md:text-lg">
            {t("subtitle")}
          </p>
          <HeroCtaButtons />
          <TrustBadges
            labels={{
              verified: tTrust("verified"),
              ssl: tTrust("ssl"),
              encryption: tTrust("encryption"),
            }}
          />
        </div>

        <HeroShieldVisual />
      </div>
    </SectionContainer>
  )
}
